// React
import { memo, useCallback, useEffect, useState } from "react";

// Servisni sloj
import { getFleetVehicleContractSaleAPI, sendFleetVehicleContractSaleEmailAPI } from "services/api/fleet/vehicles/contracts/api";
import { FleetVehicleContractSale } from "services/api/fleet/vehicles/contracts/types";
import { transformFleetDocumentUploadToFileExtended } from "services/api/fleet/vehicles/offers/transformations";

// UI
import { FileExtended } from "ui/components/FileUpload/FileDropZone/types";
import { EmailSendModal } from "ui/components/Modal/EmailSendModal";
import { EmailSendData } from "ui/components/Modal/EmailSendModal/types";

import { ContractEmailModalProps } from "./types";

/**
 * Slanje ugovora o prodaji e-mailom. PDF ugovora se dohvaća sa servera i nudi kao privitak,
 * a uspješno slanje označava korak "Poslan" u traci statusa.
 */
const ContractEmailModal: React.FC<ContractEmailModalProps> = (props) => {
  const { show, onHide, formValues, onSent } = props;

  const [pdfAttachment, setPdfAttachment] = useState<FileExtended | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchPdfAttachment = useCallback(async () => {
    if (!formValues.id) return;

    setIsLoading(true);

    try {
      const result: FleetVehicleContractSale = await getFleetVehicleContractSaleAPI(formValues.id);

      if (result.pdfUpload) {
        setPdfAttachment(transformFleetDocumentUploadToFileExtended(result.pdfUpload));
      }
    } catch {
      // greška se prikazuje kroz snackbar
    }

    setIsLoading(false);
  }, [formValues.id]);

  useEffect(() => {
    if (!show) return;

    setPdfAttachment(null);
    fetchPdfAttachment();
  }, [show, fetchPdfAttachment]);

  const handleSend = useCallback(async (data: EmailSendData) => {
    const sent = await sendFleetVehicleContractSaleEmailAPI(formValues.id!, data);

    if (sent) {
      onSent();
    }

    return sent;
  }, [formValues.id, onSent]);

  return (
    <EmailSendModal
      show={show}
      onHide={onHide}
      title={`Slanje putem e-maila [Ugovor ${formValues.contractNumber ?? ""}]`}
      initialFormValues={{
        subject: `Ugovor ${formValues.contractNumber ?? ""}`,
        content: `Poštovani,\n\nu privitku e-maila šaljemo Ugovor o kupoprodaji vozila.\n\nLijep pozdrav`,
        pdfAttachment: pdfAttachment,
      }}
      contactId={formValues.buyerContactId ?? undefined}
      onSend={handleSend}
      isLoading={isLoading}
    />
  );
};

export default memo(ContractEmailModal);
